module.exports = "<p>\n  update-popup works!\n</p>\n"